import { logSentryErrorAndGetTraceId } from '@node-space/utils'
import { BaseErrorResponse } from 'types/errors'
import { useVerticalContext } from './context/useVerticalContext'
import { useAccountPreferenceMutation } from './mutations/useAccountPreferenceMutation'
import { useMappedErrorMessage } from './useMappedErrorMessage'

export const useConfirmIndustryPreference = () => {
  const { setIsIndustryConfirmed } = useVerticalContext()

  const {
    requestError: updateIndustryRequestError,
    setRequestError,
    resetRequestError,
  } = useMappedErrorMessage()

  const { mutate: putIndustryPreference, isPending: isUpdatingIndustryPreference } =
    useAccountPreferenceMutation<boolean>()

  const onUpdateIndustryPreference = (
    value: boolean,
    onSuccess?: () => void,
    onError?: (error: BaseErrorResponse) => void
  ) => {
    resetRequestError()
    putIndustryPreference(
      { preferenceKey: 'isIndustryVerticalConfirmed', value },
      {
        onSuccess: () => {
          setIsIndustryConfirmed(value)
          onSuccess?.()
        },
        onError: (error: BaseErrorResponse) => {
          if (onError) {
            onError(error)
            return
          }
          const sentryTraceId = logSentryErrorAndGetTraceId('putVerticalPreference', error)
          setRequestError({
            errorCode: error?.status,
            sentryTraceId,
            show: true,
          })
        },
      }
    )
  }

  return {
    isUpdatingIndustryPreference,
    updateIndustryRequestError,
    onUpdateIndustryPreference,
  }
}
